// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-page {
  padding: 40px;
  min-height: calc(100vh - 65px);
  background-color: #ded8d1;
  overflow: hidden;
}

.table-container {
  max-width: 1200px;
  margin: 0 auto;
}

.konva-container {
  margin-top: 20px;
  overflow: hidden;
}

.zoom-controls {
  position: fixed;
  right: 20px;
  top: 90px; /* Position below navbar */
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1001;
}

.zoom-button {
  width: 60px;
  height: 60px;
  background-color: #df2d11;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease;
  color: white;
}

.zoom-button:hover {
  transform: scale(1.05);
}

.zoom-button svg {
  width: 30px;
  height: 30px;
  color: #fff !important;
  /* Remove position relative and top offset */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Remove the individual bottom positioning */
.zoom-in, .zoom-out {
  bottom: auto;
}

/* Remove cursor management styles */
.konvajs-content canvas {
  cursor: default;
}

/* When dragging a token, show grabbing cursor */
.dragging-token {
  cursor: grabbing !important;
}

@media (max-width: 576px) {
  .zoom-controls {
    right: 16px;
  }
}

/* Custom selection styling for HP input */
.hp-input::selection {
  background-color: #FFFFFF !important; /* Gold with !important flag */
  color: black !important;              /* Text color with !important flag */
}

/* Firefox requires a separate rule */
.hp-input::-moz-selection {
  background-color: #FFD700 !important; /* Gold with !important flag */
  color: black !important;              /* Text color with !important flag */
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Table/Table.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS,EAAE,0BAA0B;EACrC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC,EAAE,8BAA8B;EACpE,uBAAuB,eAAe,oCAAoC;AAC5E;;AAEA,qCAAqC;AACrC;EACE,oCAAoC,EAAE,8BAA8B;EACpE,uBAAuB,eAAe,oCAAoC;AAC5E","sourcesContent":[".table-page {\n  padding: 40px;\n  min-height: calc(100vh - 65px);\n  background-color: #ded8d1;\n  overflow: hidden;\n}\n\n.table-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.konva-container {\n  margin-top: 20px;\n  overflow: hidden;\n}\n\n.zoom-controls {\n  position: fixed;\n  right: 20px;\n  top: 90px; /* Position below navbar */\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  z-index: 1001;\n}\n\n.zoom-button {\n  width: 60px;\n  height: 60px;\n  background-color: #df2d11;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  box-sizing: border-box;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease;\n  color: white;\n}\n\n.zoom-button:hover {\n  transform: scale(1.05);\n}\n\n.zoom-button svg {\n  width: 30px;\n  height: 30px;\n  color: #fff !important;\n  /* Remove position relative and top offset */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Remove the individual bottom positioning */\n.zoom-in, .zoom-out {\n  bottom: auto;\n}\n\n/* Remove cursor management styles */\n.konvajs-content canvas {\n  cursor: default;\n}\n\n/* When dragging a token, show grabbing cursor */\n.dragging-token {\n  cursor: grabbing !important;\n}\n\n@media (max-width: 576px) {\n  .zoom-controls {\n    right: 16px;\n  }\n}\n\n/* Custom selection styling for HP input */\n.hp-input::selection {\n  background-color: #FFFFFF !important; /* Gold with !important flag */\n  color: black !important;              /* Text color with !important flag */\n}\n\n/* Firefox requires a separate rule */\n.hp-input::-moz-selection {\n  background-color: #FFD700 !important; /* Gold with !important flag */\n  color: black !important;              /* Text color with !important flag */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
